import React from "react";

export type BadgeProps = {
  status: "NEW" | "WAITING_FOR_PAYMENT" | "PAID" | "DONE" | "CANCELED";
  outline?: boolean; // Optional prop for outline style
};

const Badge: React.FC<BadgeProps> = ({ status, outline = false }) => {
  // Mapping statuses to colors
  const statusColors = {
    NEW: {
      background: "bg-blue-500",
      text: "text-white",
      border: "border-blue-500",
    },
    WAITING_FOR_PAYMENT: {
      background: "bg-yellow-500",
      text: "text-white",
      border: "border-yellow-500",
    },
    ON_PROCESS: {
      background: "bg-yellow-500",
      text: "text-white",
      border: "border-yellow-500",
    },
    FAILED: {
      background: "bg-red-500",
      text: "text-white",
      border: "border-red-500",
    },
    SUCCESS: {
      background: "bg-green-500",
      text: "text-white",
      border: "border-green-500",
    },
    PAID: {
      background: "bg-green-500",
      text: "text-white",
      border: "border-green-500",
    },
    DONE: {
      background: "bg-gray-500",
      text: "text-white",
      border: "border-gray-500",
    },
    CANCELED: {
      background: "bg-red-500",
      text: "text-white",
      border: "border-red-500",
    },
  };

  const { background, text, border } = statusColors[status];

  return (
    <span
      className={`rounded-md font-medium px-2 py-[2px] text-[10px] ${
        outline
          ? `border ${border} ${text} bg-transparent`
          : `${background} ${text}`
      }`}
    >
      {status}
    </span>
  );
};

export default Badge;
